import { map } from 'rxjs/operators';
import { Injectable, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { UserSettings } from '../_models/userSettings';
import { environment } from '../../../environments/environment';
import {
  ConfigurationColumnTableFA,
  configurationColumnTableFA,
} from '../../../assets/data/enum/configurationColumnTableFA';
import { configurationColumnTableStableLoads } from '../../../assets/data/enum/configurationColumnTableStableLoads';
import { configurationColumnTableLoads } from '../../../assets/data/enum/configurationColumnTableLoads';
import { configurationColumnTableStableA } from '../../../assets/data/enum/configurationColumnTableStableA';
import { ThemeConfig } from '../../../assets/data/enum/themeConfig';
import { SAASBRANDNAME } from '../../../assets/data/enum/saasBrandName.enum';
import { configurationColumnTableStableLoadsGRANLATTE } from '../../../assets/data/enum/configurationColumnTableStableLoadsGRANLATTE';
import { configurationColumnTableDA } from '../../../assets/data/enum/configurationColumnTableDa';
import { configurationColumnTableFAPioneerFields } from '../../../assets/data/enum/configurationColumnTableFAPioneerFields';

@Injectable()
export class UserSettingsService {
  defaultConfigurationColumnTableFA: ConfigurationColumnTableFA = configurationColumnTableFA;
  defaultConfigurationColumnTableDA = configurationColumnTableDA;
  defaultConfigurationColumnTableStableA = configurationColumnTableStableA;
  defaultConfigurationColumnTableStableLoads = configurationColumnTableStableLoads;
  defaultConfigurationColumnTableStableLoadsGRANLATTE =
    configurationColumnTableStableLoadsGRANLATTE;
  defaultConfigurationColumnTableLoads = configurationColumnTableLoads;
  // ? This configuration is exactly the same as configurationColumnTableFA;
  // ? Why do we need it???
  defaultConfigurationColumnTablePioneerFields: ConfigurationColumnTableFA =
    configurationColumnTableFAPioneerFields;
  private apiBaseUrl = environment.apiBaseUrl;
  themeConfig = ThemeConfig;
  brand = SAASBRANDNAME;

  public configurationColumnTableFASignal = signal<any>(null);

  constructor(private http: HttpClient) {
    //! Ask Product if this logic is still needed
    if (
      this.themeConfig.brand == this.brand.BARILLA ||
      this.themeConfig.brand == this.brand.IFARMS
    ) {
      delete this.defaultConfigurationColumnTableFA['checks'];
    }
  }

  saveUserSettings(activityUserId): Observable<UserSettings> {
    return this.http
      .post<UserSettings>(this.apiBaseUrl + 'api/private/v1/userSettings', activityUserId)
      .pipe(map((response) => response));
  }

  updateUserSettings(activityUserSettings: UserSettings): Observable<UserSettings> {
    return this.http
      .put<UserSettings>(
        this.apiBaseUrl + 'api/private/v1/userSettings/' + activityUserSettings.user.id,
        activityUserSettings
      )
      .pipe(map((response) => response));
  }

  getConfigurationColumnTableFA(): ConfigurationColumnTableFA {
    const rawConfig = localStorage.getItem('configurationColumnTable');
    const savedConfig = rawConfig ? (JSON.parse(rawConfig) as ConfigurationColumnTableFA) : null;

    if (savedConfig) {
      return savedConfig;
    }

    return this.themeConfig.brand === this.brand.PIONEERFIELDS
      ? this.defaultConfigurationColumnTablePioneerFields
      : this.defaultConfigurationColumnTableFA;
  }

  getConfigurationColumnTableDA() {
    return (
      JSON.parse(localStorage.getItem('configurationColumnTableDA')) ??
      this.defaultConfigurationColumnTableDA
    );
  }

  getConfigurationColumnTableStableLoads() {
    return (
      JSON.parse(localStorage.getItem('configurationColumnTableStableLoads')) ??
      this.defaultConfigurationColumnTableStableLoads
    );
  }

  getConfigurationColumnTableStableLoadsGRANLATTE() {
    return (
      JSON.parse(localStorage.getItem('configurationColumnTableStableLoads')) ??
      this.defaultConfigurationColumnTableStableLoadsGRANLATTE
    );
  }

  getConfigurationColumnTableLoads() {
    return (
      JSON.parse(localStorage.getItem('configurationColumnTableLoads')) ??
      this.defaultConfigurationColumnTableLoads
    );
  }

  getConfigurationColumnTableStableA() {
    return (
      JSON.parse(localStorage.getItem('configurationColumnTableStableA')) ??
      this.defaultConfigurationColumnTableStableA
    );
  }

  setConfigurationColumnTableFA(configurationColumnTable: ConfigurationColumnTableFA) {
    localStorage.setItem('configurationColumnTable', JSON.stringify(configurationColumnTable));
  }

  setConfigurationColumnTableStableA(configurationColumnTable) {
    localStorage.setItem(
      'configurationColumnTableStableA',
      JSON.stringify(configurationColumnTable)
    );
  }

  setConfigurationColumnTableStableLoads(configurationColumnTable) {
    localStorage.setItem(
      'configurationColumnTableStableLoads',
      JSON.stringify(configurationColumnTable)
    );
  }

  setConfigurationColumnTableLoads(configurationColumnTable) {
    localStorage.setItem('configurationColumnTableLoads', JSON.stringify(configurationColumnTable));
  }
}
